"use client";
import React, { useState, useEffect } from "react";
import { Drawer } from "vaul";
import { usePWA } from "@/utlis/usePWA";
import { useIsMobile } from "@/utlis/useIsMobile";
import { useT } from "@/context/I18nContext";

const SORT_VALUES = ["newest", "name-asc", "name-desc", "price-asc", "price-desc"];

export default function Sorting({ onSortChange }) {
	const { t } = useT();
	const sortingOptions = SORT_VALUES.map((value) => ({
		value,
		text: t(`sort_${value.replace(/-/g, "_")}`),
	}));

	const [selectedOption, setSelectedOption] = useState(sortingOptions[0]);
	const [open, setOpen] = useState(false);

	const isPWA = usePWA();
	const isMobile = useIsMobile();
	const isCompact = isPWA || isMobile;

	useEffect(() => {
		setSelectedOption((prev) => sortingOptions.find((o) => o.value === prev.value) ?? sortingOptions[0]);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [t]);

	const handleSelect = (item) => {
		setSelectedOption(item);
		setOpen(false);
		onSortChange?.(item.value);
	};

	if (isCompact) {
		return (
			<Drawer.Root open={open} onOpenChange={setOpen}>
				<style>{`
					.sort-trigger {
						display: flex;
						align-items: center;
						gap: 8px;
						cursor: pointer;
					}
					.sort-drawer-overlay {
						position: fixed;
						inset: 0;
						background: rgba(0, 0, 0, 0.45);
						z-index: 100000;
					}
					.sort-drawer-content {
						background: #fff;
						display: flex;
						flex-direction: column;
						border-radius: 20px 20px 0 0;
						margin-top: -1px;
						height: auto;
						max-height: 75vh;
						position: fixed;
						bottom: 0;
						left: 0;
						right: 0;
						z-index: 100000;
						padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
					}
					.sort-drawer-body {
						padding: 6px 18px 4px;
						overflow-y: auto;
					}
					.sort-drawer-title {
						font-size: 15px;
						font-weight: 700;
						color: #111;
						margin: 4px 0 14px;
					}
					.sort-option-list {
						display: flex;
						flex-direction: column;
						gap: 2px;
						margin-bottom: 12px;
					}
					.sort-option {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						padding: 12px;
						background: transparent;
						border: none;
						border-radius: 12px;
						cursor: pointer;
						font-size: 15px;
						text-align: left;
						-webkit-tap-highlight-color: transparent;
						transition: background 0.15s;
					}
					.sort-option:active {
						background: #f0f2f5;
					}
					.sort-option.selected {
						background: #eef5ff;
					}
				`}</style>

				<Drawer.Trigger asChild>
					<div className='btn-select sort-trigger'>
						<span className='text-sort-value'>{selectedOption.text}</span>
						<span className='icon icon-arrow-down' />
					</div>
				</Drawer.Trigger>

				<Drawer.Portal>
					<Drawer.Overlay className='sort-drawer-overlay' />
					<Drawer.Content className='sort-drawer-content'>
						<Drawer.Handle />
						<div className='sort-drawer-body'>
							<Drawer.Title className='sort-drawer-title'>{t("shop_sort_title")}</Drawer.Title>
							<div className='sort-option-list'>
								{sortingOptions.map((item, index) => (
									<button
										key={index}
										type='button'
										className={`sort-option${item.value === selectedOption.value ? " selected" : ""}`}
										onClick={() => handleSelect(item)}
										style={{
											fontWeight: item.value === selectedOption.value ? 600 : 400,
											color: item.value === selectedOption.value ? "#0074d9" : "#333",
										}}>
										<span>{item.text}</span>
										{item.value === selectedOption.value && (
											<svg
												width='14'
												height='14'
												viewBox='0 0 24 24'
												fill='none'
												stroke='#0074d9'
												strokeWidth='3'
												strokeLinecap='round'
												strokeLinejoin='round'>
												<polyline points='20 6 9 17 4 12' />
											</svg>
										)}
									</button>
								))}
							</div>
						</div>
					</Drawer.Content>
				</Drawer.Portal>
			</Drawer.Root>
		);
	}

	return (
		<>
			<div className='btn-select'>
				<span className='text-sort-value'>{selectedOption.text}</span>
				<span className='icon icon-arrow-down' />
			</div>
			<div className='dropdown-menu'>
				{sortingOptions.map((item, index) => (
					<div
						key={index}
						onClick={() => handleSelect(item)}
						className={`select-item ${item.value === selectedOption.value ? "active" : ""}`}>
						<span className='text-value-item'>{item.text}</span>
					</div>
				))}
			</div>
		</>
	);
}
